import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-tab',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./tabs.component.scss'],

})
export class TabComponent {
  @Input() tabTitle: string;
  @Input() selected = false;
  @Input() active = true;
  /** Highlights the tab header to draw attention, e.g. when there are active faults. */
  @Input() alert = false;
  /** Announced by screen readers while `alert` is set, since the highlight itself is visual. */
  @Input() alertLabel = '';
  @Output() tabClick = new EventEmitter();

  constructor(
    public translate: TranslateService,
  ) { }
}
